export const FIFA_TOP_FORWARDS = [{
  id: 'Wn6E2SED',
  name: 'Мбаппе К.',
  team: 'Франция',
  teamId: 'QkGeVG1n',
  goals: 8,
  flagUrl: 'https://cdn.nur.kz/static/football/FR.png',
  countryCode: 'FR'
}, {
  id: 'vgOOdZbd',
  name: 'Месси Л.',
  team: 'Аргентина',
  teamId: 'f9OppQjp',
  goals: 7,
  flagUrl: 'https://cdn.nur.kz/static/football/AR.png',
  countryCode: 'AR'
}, {
  id: 'bBHauDIC',
  name: 'Альварес Х.',
  team: 'Аргентина',
  teamId: 'f9OppQjp',
  goals: 4,
  flagUrl: 'https://cdn.nur.kz/static/football/AR.png',
  countryCode: 'AR'
}, {
  id: 'AJPBp2as',
  name: 'Жиру О.',
  team: 'Франция',
  teamId: 'QkGeVG1n',
  goals: 4,
  flagUrl: 'https://cdn.nur.kz/static/football/FR.png',
  countryCode: 'FR'
}, {
  id: 'fmkHs3aU',
  name: 'Мората А.',
  team: 'Испания',
  teamId: 'bLyo6mco',
  goals: 3,
  flagUrl: 'https://cdn.nur.kz/static/football/ES.png',
  countryCode: 'ES'
}, {
  id: 'xfW2M1Tt',
  name: 'Рамуш Г.',
  team: 'Португалия',
  teamId: 'WvJrjFVN',
  goals: 3,
  flagUrl: 'https://cdn.nur.kz/static/football/PT.png',
  countryCode: 'PT'
}, {
  id: 'pWyuBud0',
  name: 'Гакпо К.',
  team: 'Нидерланды',
  teamId: 'WYintcWb',
  goals: 3,
  flagUrl: 'https://cdn.nur.kz/static/football/NL.png',
  countryCode: 'NL'
}, {
  id: 'COnT2Lh0',
  name: 'Рэшфорд М.',
  team: 'Англия',
  teamId: 'j9N9ZNFA',
  goals: 3,
  flagUrl: 'https://cdn.nur.kz/static/football/GB.png',
  countryCode: 'GB'
}, {
  id: 'K82Dz773',
  name: 'Ришарлисон',
  team: 'Бразилия',
  teamId: 'I9l9aqLq',
  goals: 3,
  flagUrl: 'https://cdn.nur.kz/static/football/BR.png',
  countryCode: 'BR'
}, {
  id: '08NLEo06',
  name: 'Сака Б.',
  team: 'Англия',
  teamId: 'j9N9ZNFA',
  goals: 3,
  flagUrl: 'https://cdn.nur.kz/static/football/GB.png',
  countryCode: 'GB'
}];
